<div class="container mt-4 shadow bg-white mb-5 pb-4">
  <div class="row">
    <div class="col">
      <h2 class="pt-4 font-weight-light">Edit User</h2>
      <hr />
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-user-form></app-user-form>
    </div>
  </div>
</div>
